/**
 * Static option lists for the Assistant settings panels.
 *
 * Providers, models, voices and their prices come from the admin-managed
 * provider catalog (see ProviderPicker); only capability lists that aren't
 * priced live here.
 */

export const LANGUAGES = [
  "English",
  "Spanish",
  "French",
  "German",
  "Arabic",
  "Portuguese",
  "Hindi",
];

export const BACKGROUND_SOUNDS = ["Off", "Office", "Café", "Custom"];
